"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MACHINE_CONFIG_TITLE = exports.SETTLEMENT_DETAIL_TITLE = exports.SETTLEMENT_LIST_TITLE = exports.CLUB_INVOICE_LIST_TITLE = exports.CLUB_INVOICE_DETAIL_TITLE = exports.ORDERS_DETAIL_TITLE = exports.REFILLS_DETAIL_TITLE = exports.PRODUCTS_EDIT_TITLE = exports.PRODUCTS_CREATE_TITLE = exports.MOBILE_PROFILE_TITLE = exports.ORDERS_LIST_TITLE = exports.REFILLS_LIST_TITLE = exports.PRODUCTS_LIST_TITLE = exports.MACHINE_LIST_TITLE = exports.HOME_TITLE = void 0;
exports.HOME_TITLE = 'Home';
exports.MACHINE_LIST_TITLE = 'machinesList';
exports.PRODUCTS_LIST_TITLE = 'productsList';
exports.REFILLS_LIST_TITLE = 'reFillsList';
exports.ORDERS_LIST_TITLE = 'ordersList';
exports.MOBILE_PROFILE_TITLE = 'profile';
exports.PRODUCTS_CREATE_TITLE = 'productsCreate';
exports.PRODUCTS_EDIT_TITLE = 'productsEdit';
exports.REFILLS_DETAIL_TITLE = 'refillsDetail';
exports.ORDERS_DETAIL_TITLE = 'orderDetail';
exports.CLUB_INVOICE_DETAIL_TITLE = 'clubInvoiceDetail';
exports.CLUB_INVOICE_LIST_TITLE = 'billingList';
exports.SETTLEMENT_LIST_TITLE = 'settlementList';
exports.SETTLEMENT_DETAIL_TITLE = 'settlementDetail';
exports.MACHINE_CONFIG_TITLE = 'config.machineSettings';
